<template>
  <div class="create-company-railbank-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i>Create company by Railsbank</span>
        
      </div>
      <el-form
        :model="companyForm"
        id="companyForm"
        ref="companyForm"
        label-width="150px"
        size="small"
        :rules="companyFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Company</el-divider>
            <el-form-item prop="company_name" label="Company Name">
              <el-input v-model="companyForm.company_name"></el-input>
            </el-form-item>

            <el-form-item prop="company_tradingName" label="Trading Name">
              <el-input v-model="companyForm.company_tradingName"></el-input>
            </el-form-item>

            <el-form-item
              prop="company_typeOfBusiness"
              label="Type Of Business"
            >
              <el-input v-model="companyForm.company_typeOfBusiness"></el-input>
            </el-form-item>

            <el-form-item
              prop="company_natureofbusiness"
              label="Nature of Business"
            >
              <!-- <el-input v-model="companyForm.company_natureofbusiness"></el-input> -->
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.company_natureofbusiness"
                :fetch-suggestions="querySearchNatureofbusiness"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item
              prop="company_regulateFinancial"
              label="Regulate Financial"
            >
              <el-switch
                v-model="companyForm.company_regulateFinancial"
              ></el-switch>
            </el-form-item>

            <el-form-item
              prop="company_registrationNumber"
              label="Registration Number"
            >
              <el-input
                v-model="companyForm.company_registrationNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company_approvedate" label="Approve Date">
              <el-date-picker
                v-model="companyForm.company_approvedate"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="company_telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="companyForm.company_telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company_webSite" label="Website">
              <el-input
                prefix-icon="el-icon-link"
                v-model="companyForm.company_webSite"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company_email" label="Email Contact">
              <el-input
                prefix-icon="el-icon-message"
                v-model="companyForm.company_email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company_addressnumber" label="Address number">
              <el-input v-model="companyForm.company_addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="company_street" label="Street">
              <el-input v-model="companyForm.company_street"></el-input>
            </el-form-item>

            <el-form-item prop="company_city" label="City">
              <el-input v-model="companyForm.company_city"></el-input>
            </el-form-item>

            <el-form-item prop="company_zipcode" label="Zipcode">
              <el-input v-model="companyForm.company_zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="company_refinement" label="Refinement">
              <el-input v-model="companyForm.company_refinement"></el-input>
            </el-form-item>

            <el-form-item prop="company_region" label="Region">
              <el-input v-model="companyForm.company_region"></el-input>
            </el-form-item>

            <el-form-item prop="company_countrycode" label="Country code">
              <!-- <el-input v-model="companyForm.company_countrycode"></el-input> -->
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.company_countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCompanyCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>

          <!--//////////////////////// Director //////////////////////////-->

          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Director</el-divider>
            <el-form-item prop="director_name" label="Director Name">
              <el-input v-model="companyForm.director_name"></el-input>
            </el-form-item>

            <el-form-item prop="director_dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="companyForm.director_dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="director_position" label="Position">
              <el-input v-model="companyForm.director_position"></el-input>
            </el-form-item>

            <el-form-item prop="director_telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="companyForm.director_telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="director_email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="companyForm.director_email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="director_nationality" label="Nationality">
              <!-- <el-input v-model="companyForm.director_nationality"></el-input> -->
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="companyForm.director_nationality"
                :fetch-suggestions="querySearchNationality"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item prop="director_identifyType" label="Identify Type">
              <!-- <el-input v-model="companyForm.director_identifyType"></el-input> -->
              <el-select v-model="companyForm.director_identifyType">
                <el-option label="Passport" value="passport"></el-option>
                <el-option
                  label="Driving Licence"
                  value="driving-licence"
                ></el-option>
                <el-option
                  label="Identity Card"
                  value="identity-card"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="director_identifyNumber"
              label="Identify Number"
            >
              <el-input
                v-model="companyForm.director_identifyNumber"
              ></el-input>
            </el-form-item>

            <el-form-item
              prop="director_identifyExpire"
              label="Identify Expire"
            >
              <el-date-picker
                v-model="companyForm.director_identifyExpire"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="director_addressnumber" label="Address number">
              <el-input v-model="companyForm.director_addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="director_street" label="Street">
              <el-input v-model="companyForm.director_street"></el-input>
            </el-form-item>

            <el-form-item prop="director_city" label="City">
              <el-input v-model="companyForm.director_city"></el-input>
            </el-form-item>

            <el-form-item prop="director_zipcode" label="Zipcode">
              <el-input v-model="companyForm.director_zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="director_refinement" label="Refinement">
              <el-input v-model="companyForm.director_refinement"></el-input>
            </el-form-item>

            <el-form-item prop="director_region" label="Region">
              <el-input v-model="companyForm.director_region"></el-input>
            </el-form-item>

            <el-form-item
              prop="director_residentCountry"
              label="Resident Country"
            >
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="companyForm.director_residentCountry"
                :fetch-suggestions="querySearchResidentCountry"
                @select="selectDirectorResidentCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>

            <el-form-item prop="director_countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.director_countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectDirectorCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center">
        <el-button type="primary" :loading="submiting" @click="submitCompany()"
          >Submit</el-button
        >
        <el-button @click="resetForm" type="warning">Reset</el-button>
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import model from "../models/vender-railbank-model";
import { getUtility } from "@/api/customer";
import { createCompany } from "@/api/company";
export default {

  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      submiting: false,
      errMsg: "",
      utility: {},
      companyForm: model.companyForm,
      companyFormRules: model.companyRules,
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    resetForm() {
      if (this.$refs.companyForm) this.$refs.companyForm.resetFields();
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;

      cb(results);
    },
    querySearchResidentCountry(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;

      cb(results);
    },
    querySearchNationality(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "nationality"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.nationality });
      });
      cb(lists);
    },
    querySearchNatureofbusiness(queryString, cb) {
      var data = this.utility.natureofbusiness;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "name"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.name });
      });
      cb(lists);
    },
    selectCompanyCountrycode(item) {
      this.companyForm.company_countrycode = item.country_code;
    },

    selectDirectorCountrycode(item) {
      this.companyForm.director_countrycode = item.country_code;
    },
    selectDirectorResidentCountrycode(item) {
      this.companyForm.director_residentCountry = item.country_code;
    },

    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    cancelForm() {
      this.$router.push('/company')
    },
    createCompany() {
      const formData = model.mapData(this.companyForm);
      this.submiting = true;
      this.errMsg = "";
      createCompany(formData).then(({ result, message }) => {
        this.submiting = false;
        if (result) {
          this.$confirm('Create Company successfully', 'Successfully', {
            confirmButtonText: 'OK',
            showCancelButton: false,
            type: 'success',
          }).then(() => {
            this.cancelForm()
          });
        } else {
          this.errMsg = message;
        }
      });
    },
    submitCompany() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          this.createCompany();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    this.getUtility();
    this.resetForm();
  },
};
</script>

<style lang="scss">
.create-company-railbank-container{
    .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 11px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

  .footer{
    border-top: 1px solid #ebeef5;
    padding-top: 20px;
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
  }
}
</style>
